"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addARepetition = void 0;
const addQuestion_1 = __importDefault(require("./addQuestion"));
const shiftSubquestionIdsForRepetition_1 = __importDefault(require("./shiftSubquestionIdsForRepetition"));
const visitQuestionNode_1 = __importDefault(require("./visitQuestionNode"));
const addARepetition = (form, questionNodeId, index = -1) => {
    const node = form.questions[questionNodeId];
    const rule = form.rules[node.questionId];
    if (rule.unLimitedTimes.enabled) {
        const parent = node.parentNodeId === 'root' ? form.questionTree : form.questions[node.parentNodeId];
        const count = node.totalRepetitions;
        const position = index === -1 ? count : index;
        if (index !== -1) {
            parent.subQuestions
                .filter(ss => ss.questionId === node.questionId)
                .reverse()
                .forEach(ss => {
                (0, shiftSubquestionIdsForRepetition_1.default)(ss, node, form, index - 1, count, 1);
                (0, visitQuestionNode_1.default)(ss, n => (0, shiftSubquestionIdsForRepetition_1.default)(n, node, form, index - 1, count, 1));
            });
        }
        const newNodeId = `${node.questionId}_${position}`;
        const newNodeContent = JSON.stringify(node).split(node.nodeId).join(newNodeId);
        const convertedNodeContent = JSON.parse(newNodeContent);
        const newNode = Object.assign(Object.assign({}, convertedNodeContent), { nodeId: newNodeId, repetitionIndex: position });
        let realIndex = -1;
        for (let i = 0; i < parent.subQuestions.length; i++) {
            const x = parent.subQuestions[i];
            if (x.questionId === node.questionId && (index === -1 || x.repetitionIndex === index)) {
                realIndex = i + 1;
            }
        }
        const child = (0, addQuestion_1.default)(form, parent, newNode, {}, rule, realIndex);
        (0, visitQuestionNode_1.default)(child, n => {
            n.repetitionAncestorId = newNodeId;
            n.repetitionIndex = position;
            n.totalRepetitions = count + 1;
        });
        parent.subQuestions
            .filter(ss => ss.questionId === newNode.questionId)
            .forEach(ss => {
            ss.totalRepetitions = count + 1;
        });
    }
};
exports.addARepetition = addARepetition;
exports.default = exports.addARepetition;
